var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PopoverContent, Heading, Text, PopoverArrow, Box, Popover, PopoverTrigger, } from 'shared/components';
export var HeaderInfoPopover = function (_a) {
    var children = _a.children, title = _a.title, description = _a.description;
    return (_jsxs(Popover, __assign({ trigger: "hover", arrowSize: 26, colorScheme: "blue", arrowShadowColor: "none" }, { children: [_jsx(PopoverTrigger, { children: children }), _jsxs(PopoverContent, __assign({ boxShadow: "0px -1px 7px rgba(0, 0, 0, 0.25)", borderWidth: "3px", borderColor: "info.base", borderRadius: '16px', pointerEvents: "none", maxW: '325px' }, { children: [_jsx(PopoverArrow, { borderColor: "info.base", borderWidth: "3px", borderRadius: '4px' }), _jsxs(Box, __assign({ padding: 4, bg: "white", borderRadius: "inherit" }, { children: [_jsx(Heading, __assign({ color: "info.dark", size: "h2", mb: 3 }, { children: title })), _jsx(Text, __assign({ size: "body1", color: "gray.600" }, { children: description }))] }))] }))] })));
};
